// extracted by mini-css-extract-plugin
module.exports = {"containerCards":"cardPc_containerCards__3jBi3","card":"cardPc_card__vmi2E","name":"cardPc_name__1IiyW","img":"cardPc_img__1Gz2u"};